import { render, staticRenderFns } from "./UMLLineElement.vue?vue&type=template&id=45e8b059&scoped=true&"
import script from "./UMLLineElement.vue?vue&type=script&lang=js&"
export * from "./UMLLineElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e8b059",
  null
  
)

export default component.exports